import { useState } from "react"
import { BASE_URL } from "../../../services/configUrls";
import axios from "axios";
import { ArrowRightLeft } from 'lucide-react';


export default function ImagePreview ({ label, value, onHandleInputChange }) {
    const [ uploadOffline, setUploadOffline ] = useState(true);

    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        // Upload instantly
        const formData = new FormData();
        formData.append("file", file);
    
        try {
          const res = await axios.post(
            `${BASE_URL}/schedule_email/upload-image`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
    
          const url = res.data.image_url;
          if(url){
            onHandleInputChange(url)
          }
        } catch (err) {
          alert(`Upload failed: ${err}`);
          console.log("Upload failed :"+err)
        }
      };

    return (
        <div>
            <label>{uploadOffline ? 'Upload image' : 'Image link'}</label><ArrowRightLeft onClick={()=>setUploadOffline(prev => !prev)} className="cursor-pointer"/>
            {/* <img src={value} alt="image" className="w-full h-[150px] object-cover border rounded-xl"/> */}
            {uploadOffline ? <input type="file" accept="image/*" onChange={handleFileSelect} className="mt-2 border w-full h-7"/> :
            <input value={value} onChange={(e)=>onHandleInputChange(e.target.value)} className="mt-2 border w-full h-7"/> }
        </div>
    )
}